import React, { Component } from "react";

class NavBar extends Component {
  state = {};
  render() {
    const {totalItems, getTotal} = this.props;
    return (
      <nav className="navbar navbar-light bg-light shadow-sm mb-4">
        <div className="container">
          <span className="navbar-brand mb-0 h1">
            Total Itmes :{" "}
            <div className="badge badge-pill badge-warning">{totalItems}</div>
          </span>
          <span className="navbar-brand mb-0 h1">
            Total Number :{" "}
            <div className="badge badge-pill badge-info">{getTotal}</div>
          </span>
        </div>
      </nav>
    );
  }
}

export default NavBar;
